import React, { useState } from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { useIntl, FormattedMessage } from 'react-intl'
import messages from '../../../../messages'
import { Grid, Button } from '@material-ui/core'
import { Field, Formik } from 'formik'
import {
  useCustomCrisprTotalValidationMutation,
  useCustomCrisprSaveToSessionMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import ValidationErrors from '../../../../validations/ValidationErrors'
import { GenomicsProperties } from '../../enum'
import * as yup from 'yup'
import { ConfigContext } from '../../Genomics'
import { convertToASCII } from '@src/routes/Configurators/utils/util'
import CircleLoader from '@src/components/CircleLoader'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import clsx from 'clsx'
import styles from '@src/routes/Configurators/utils/styles'
import { SequenceEntryItemProps } from '@src/routes/Configurators/components/ConfiguratorTypes'

const useStyles = makeStyles((theme: Theme) => {
  return {
    mt24: {
      marginTop: theme.spacing(6),
    },
    disableText: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.disabled,
      '& .MuiTypography-colorPrimary': {
        color: theme.palette.text.disabled,
      },
      margin: theme.spacing(0, 0, 2),
      display: 'inline-flex',
    },
    sequenceInput: {
      '&.Mui-error': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error:hover': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      '& input': {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
        },
      },
    },
    sequenceLabel: {
      '& label': {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: 1.43,
      },
    },
    addToListButton: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(1.5, 8),
    },

    baseCount: {
      fontSize: theme.typography.pxToRem(14),
      margin: theme.spacing(0, 0, 2),
    },

    baseContent: {
      fontSize: theme.typography.pxToRem(12),
    },
    sequenceHelpText: {
      fontSize: theme.typography.pxToRem(12),
    },

    validateError: {
      marginLeft: theme.spacing(-4),
      '&.Mui-error.Mui-focused': {
        border: '0 none',
        borderBottom: `1px solid ${theme.palette.error.main}`,
      },
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(10),
    },
    errorInputField: {
      '& label': {
        color: theme.palette.error.main,
        fontWeight: theme.typography.fontWeightBold,
        lineHeight: 1.43,
      },
      '& $sequenceInput': {
        border: `2px solid ${theme.palette.error.main}  !important`,
        boxShadow: 'none !important',
      },
    },
  }
})
let insertPos = 0
const SequenceEntryItem = ({
  productDetails,
  disable,
  instructions,
  setErrorMsg,
}: SequenceEntryItemProps) => {
  const classes = useStyles()
  const { state, dispatch } = React.useContext(ConfigContext)
  const {
    sessionData,
    currentSubModelIndex,
    currentItemErrors,
    customCrisprIndex,
    validateOnClick,
    sessionListSubModel,
  } = state
  const seqInput: any = document.getElementById('sequence')
  const [name, setName] = useState<string | null | undefined>('')
  const [geneId, setGeneId] = useState<string | null | undefined>('')
  const [geneSymbol, setGeneSymbol] = useState<string | null | undefined>('')
  const [sequence, setSequence] = useState<string | null | undefined>('')
  const [nameValidationErrors, setNameValidationErrors] = useState<string[]>([])
  const [isSave, setIsSave] = useState(false)
  const [isValidationErrors, setIsValidationErrors] = useState<boolean>(false)

  const [geneIdValidationErrors, setGeneIdValidationErrors] = useState<
    string[]
  >([])
  const [geneSymValidationErrors, setGeneSymValidationErrors] = useState<
    string[]
  >([])
  const intl = useIntl()
  const GlobalCSS = styles()
  const [sequenceValidation, setSequenceValidation] = useState<string[]>([])
  const [baseCount, setBaseCount] = useState<string>('0')
  const debouncedSequenceData = useDebounce(
    sequence,
    GenomicsProperties.SEQUENCE_API_TIME
  )

  const [isSequenceEmpty, setIsSequenceEmpty] = useState<boolean>(false)
  const [isSequence, setIsSequence] = useState(false)

  let splChar = ''

  const [customCrisprTotalValidationMutation, { loading: validationLoading }] =
    useCustomCrisprTotalValidationMutation()

  const [customCrisprSaveToSession, { loading: saveLoading }] =
    useCustomCrisprSaveToSessionMutation()

  const callSeqValidationAPI = async () => {
    setIsSave(false)
    const response = await customCrisprTotalValidationMutation({
      variables: { input: sessionData, productInput: productDetails },
    })
    let validationResponse
    if (response?.data?.customCrisprTotalValidation)
      validationResponse = response?.data?.customCrisprTotalValidation[0]
    if (validationResponse && !validationResponse.serverError) {
      const listSubModels = validationResponse?.listSubModels
      if (listSubModels) {
        const validationError =
          listSubModels[currentSubModelIndex]?.listSubModelErrors
        const error: any[] = []
        if (validationError.length) {
          validationError.forEach((item) => {
            if (item?.key === GenomicsProperties.SequenceKey) {
              setBaseCount('--')
              setIsValidationErrors(true)
              error.push(item?.value)
            } else {
              setIsValidationErrors(false)
            }
          })
        } else {
          setSequenceValidation([])
        }
        setSequenceValidation(error)
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }
  //function to extract the special characters from the string passed
  const getOligoNameSpecialCharacter = (field, val): string => {
    switch (field) {
      case GenomicsProperties.Name: {
        setName(val)
        break
      }
      case GenomicsProperties.GeneId: {
        setGeneId(val)
        break
      }
      case GenomicsProperties.GeneSymbol: {
        setGeneSymbol(val)
        break
      }
      default:
        return ''
    }
    splChar = ''
    if (val) {
      val.split('').forEach((c) => {
        if (
          !c.match(/^[a-zA-Z0-9_#%&*().,:+.[\-\]/ ]*$/) &&
          !splChar.includes(c)
        ) {
          if (splChar === '') {
            splChar = c
          } else {
            splChar = splChar + ', ' + c
          }
        }
      })
    }
    return splChar
  }
  React.useEffect(() => {
    if (seqInput) {
      seqInput.selectionEnd = insertPos
    }
    // TODO: need a test before we refactor these dependencies
  }, [sequence])
  React.useEffect(() => {
    if (validateOnClick) {
      if (
        !sequenceValidation.length &&
        !nameValidationErrors.length &&
        !geneSymValidationErrors.length &&
        !geneIdValidationErrors.length &&
        !isValidationErrors
      ) {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: '',
        })
        dispatch({
          type: 'VALIDATE_ON_CLICK',
          data: false,
        })
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [
    sequenceValidation,
    nameValidationErrors,
    geneSymValidationErrors,
    geneIdValidationErrors,
    isValidationErrors,
  ])
  const countText = (value) => {
    insertPos = seqInput.selectionStart
    const val = value
      .replace(/[\u007F-\u00A0]/g, '')
      .replace(/\\f/g, '')
      .replace(/%/g, '')
      .toUpperCase()
      .replace(new RegExp('U', 'g'), 'T')
    setSequence(val)
    sessionData[0].listSubModels[currentSubModelIndex].sequence = val
    sessionData[0].listSubModels[currentSubModelIndex].baseCount = val
      .split(' ')
      .join('').length
    setBaseCount(val.split(' ').join('').length)
    //updating pageNo = 0 to disable side bar for other pages
    sessionData[0].pageNo = 0
    if (sessionData[0].physicalMaterial !== '')
      sessionData[0].physicalMaterial = ''
    if (state.stepNo !== 0) {
      dispatch({ type: 'SET_STEP_NO', data: 0 })
    }
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
  }

  const handleOnBlur = (event) => {
    const { name, value } = event.target
    if (name === GenomicsProperties.Name) {
      sessionData[0].listSubModels[currentSubModelIndex][name] = value.trim()
    } else {
      sessionData[0].listSubModels[currentSubModelIndex][name] = value
    }
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
  }

  React.useEffect(
    () => {
      // Make sure we have a value (user has entered something in input)
      if (debouncedSequenceData) {
        if (isSequence) {
          callSeqValidationAPI()
        }
        setIsSequence(false)
      }
      if (sequence === '' && isSequenceEmpty) {
        callSeqValidationAPI()
      }
    },
    // This is the useEffect input array
    // Our useEffect function will only execute if this value changes ...
    // ... and thanks to our hook it will only change if the original ...
    // value (searchTerm) hasn't changed for more than 500ms.
    // TODO: need a test before we refactor these dependencies

    [debouncedSequenceData]
  )
  //To clear all the Manual entry page text fields when
  //session data is cleared either by page refresh or deleteAll
  React.useEffect(() => {
    if (
      !sessionListSubModel?.length ||
      (sessionListSubModel?.length === 1 &&
        sessionListSubModel[0].name === '' &&
        sessionListSubModel[0].sequence === '')
    ) {
      setName('')
      setGeneId('')
      setGeneSymbol('')
      setSequence('')
      setBaseCount('0')
      setIsSequenceEmpty(false)
      setNameValidationErrors([])
      setGeneIdValidationErrors([])
      setGeneSymValidationErrors([])
      setSequenceValidation([])
    }
  }, [state.sessionListSubModel])

  React.useEffect(() => {
    const nameErrors: string[] = []
    const sequenceErrors: string[] = []
    currentItemErrors.forEach((error) => {
      if (error?.key === GenomicsProperties.SequenceKey) {
        sequenceErrors.push(error?.value)
      }
      if (error?.key === GenomicsProperties.Name) {
        nameErrors.push(error.value)
      }
    })
    setSequenceValidation(sequenceErrors)
    setNameValidationErrors(nameErrors)
  }, [currentItemErrors])

  const setInitialState = () => {
    return {
      name: '',
      geneId: '',
      geneSymbol: '',
      sequence: '',
      id: customCrisprIndex + 1,
      isOverridden: false,
      baseCount: 0,
      isCurrentForm: true,
      price: '',
      cartId: '',
      itemId: '',
    }
  }

  const handleAddToList = async () => {
    setIsSave(true)
    const response = await customCrisprTotalValidationMutation({
      variables: { input: sessionData, productInput: productDetails },
    })
    let validationResponse
    if (response?.data?.customCrisprTotalValidation)
      validationResponse = response?.data?.customCrisprTotalValidation[0]
    if (validationResponse && !validationResponse.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      const listSubModels = validationResponse.listSubModels
      const filteredErrors = listSubModels?.filter(
        (listSubModel) => listSubModel?.listSubModelErrors?.length
      )
      if (filteredErrors?.length) {
        const errors: any[] = []
        const validatErrorList = filteredErrors[0]?.listSubModelErrors
        if (validatErrorList) {
          validatErrorList.forEach((error) => {
            if (error && error.key === GenomicsProperties.SequenceKey) {
              errors.push({
                key: error?.key,
                value: error?.value,
              })
              setBaseCount('--')
            }
            if (error && error.key === GenomicsProperties.Name) {
              errors.push({
                key: error?.key,
                value: error?.value,
              })
            }
          })
        }
        dispatch({
          type: 'UPDATE_ERRORS',
          data: errors,
        })
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        if (errors.length) {
          window.scrollTo(0, 0)
        }
      } else {
        if (sessionData[0].listSubModels.length > 100) {
          dispatch({ type: 'IS_DISPLAY_ERROR', data: true })
          setErrorMsg(intl.formatMessage(messages.CONF_UPLOAD_ERROR_MSG))
          window.scrollTo(0, 0)
        } else {
          sessionData[0].listSubModels[currentSubModelIndex].isCurrentForm =
            false
          await customCrisprSaveToSession({
            variables: { input: sessionData, productInput: productDetails },
          })
          dispatch({
            type: 'CRISPR_SEQUENCE_LIST',
            data: true,
          })
          dispatch({
            type: 'UPDATE_LIST_SUB_MODEL',
            data: [...sessionData[0].listSubModels],
          })

          const emptyStateObj = Object.assign({}, setInitialState())
          sessionData[0].listSubModels.push(emptyStateObj)
          //updating pageNo = 0 to disable side bar for other pages
          sessionData[0].pageNo = 0
          if (sessionData[0].physicalMaterial !== '')
            sessionData[0].physicalMaterial = ''
          if (state.stepNo !== 0) {
            dispatch({ type: 'SET_STEP_NO', data: 0 })
          }
          dispatch({
            type: 'UPDATE_INPUT',
            data: [...sessionData],
          })

          dispatch({
            type: 'UPDATE_CURRENT_INDEX',
            data: sessionData[0].listSubModels.length - 1,
          })
          dispatch({
            type: 'UPDATE_CRISPR_CURRENT_INDEX',
            data: customCrisprIndex + 1,
          })
          dispatch({
            type: 'SET_PAGE_ERROR',
            data: '',
          })
          //dispatch and prop method 'setErrorMsg' set for maximum line item limit
          dispatch({ type: 'IS_DISPLAY_ERROR', data: false })
          setErrorMsg('')
          dispatch({
            type: 'UPDATE_ERRORS',
            data: [],
          })

          setName('')
          setGeneId('')
          setGeneSymbol('')
          setSequence('')
          setBaseCount('0')
          setIsSequenceEmpty(false)
        }
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
    dispatch({
      type: 'VALIDATE_ON_CLICK',
      data: true,
    })
  }

  const handleNameChange = (value) => {
    const oligoNameSpecialCharacter = getOligoNameSpecialCharacter(
      GenomicsProperties.Name,
      value
    )
    const validator = yup
      .string()
      .trim()
      .required(intl.formatMessage(messages.CONF_REQUIRED_FIELD))
      .max(
        GenomicsProperties.NameMaxLength,
        intl.formatMessage(
          messages.CONF_ADD_INFO_MAX_VALIDATION_MSG_WITH_LENGTH,
          { length: GenomicsProperties.NameMaxLength }
        )
      )
      .matches(
        /^[a-zA-Z0-9_#%&*().,:+.[\-\]/ ]*$/,
        intl.formatMessage(
          messages.CONF_OLIGO_NAME_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE,
          { characters: oligoNameSpecialCharacter }
        )
      )
    const errors: string[] = []
    try {
      setNameValidationErrors([])
      validator.validateSync(value, { abortEarly: false })
    } catch (error: any) {
      for (const err of error.errors) {
        errors.push(err)
      }
      setNameValidationErrors(errors)
    }
    return null
  }

  const handleGeneIdChange = (value) => {
    const oligoNameSpecialCharacter = getOligoNameSpecialCharacter(
      GenomicsProperties.GeneId,
      value
    )
    const validator = yup
      .string()
      .max(
        GenomicsProperties.GeneLength,
        intl.formatMessage(
          messages.CONF_ADD_INFO_MAX_VALIDATION_MSG_WITH_LENGTH,
          { length: GenomicsProperties.GeneLength }
        )
      )
      .matches(
        /^[a-zA-Z0-9_#%&*().,:+.[\-\]/ ]*$/,
        intl.formatMessage(
          messages.CONF_GENE_ID_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE,
          { character: oligoNameSpecialCharacter }
        )
      )
    const errors: string[] = []
    try {
      setGeneIdValidationErrors([])
      validator.validateSync(value, { abortEarly: false })
    } catch (error: any) {
      for (const err of error.errors) {
        errors.push(err)
      }
      setGeneIdValidationErrors(errors)
    }
    return null
  }

  const handleGeneSymbolChange = (value) => {
    const oligoNameSpecialCharacter = getOligoNameSpecialCharacter(
      GenomicsProperties.GeneSymbol,
      value
    )
    const validator = yup
      .string()
      .max(
        GenomicsProperties.GeneLength,
        intl.formatMessage(
          messages.CONF_ADD_INFO_MAX_VALIDATION_MSG_WITH_LENGTH,
          { length: GenomicsProperties.GeneLength }
        )
      )
      .matches(
        /^[a-zA-Z0-9_#%&*().,:+.[\-\]/ ]*$/,
        intl.formatMessage(
          messages.CONF_GENE_SYMBOL_SPECIAL_CHARACTER_MASSAGE_WITH_SPACE,
          { character: oligoNameSpecialCharacter }
        )
      )
    const errors: string[] = []
    try {
      setGeneSymValidationErrors([])
      validator.validateSync(value, { abortEarly: false })
    } catch (error: any) {
      for (const err of error.errors) {
        errors.push(err)
      }
      setGeneSymValidationErrors(errors)
    }
    return null
  }

  const handleOnChange = (event) => {
    const { name, value } = event.target
    switch (name) {
      case GenomicsProperties.Name: {
        handleNameChange(value)
        break
      }

      case GenomicsProperties.GeneId: {
        handleGeneIdChange(value)
        break
      }

      case GenomicsProperties.GeneSymbol: {
        handleGeneSymbolChange(value)
        break
      }

      default:
        return null
    }
    //updating pageNo = 0 to disable side bar for other pages
    sessionData[0].pageNo = 0
    if (state.stepNo !== 0) {
      dispatch({ type: 'SET_STEP_NO', data: 0 })
    }
    if (sessionData[0].physicalMaterial !== '') {
      state.sessionData[0].physicalMaterial = ''
      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
    }
    return undefined
  }

  return (
    <div>
      <Formik
        initialValues={{}}
        validateOnChange={false}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        {() => (
          <>
            <Grid container direction="row" spacing={9}>
              <Grid item sm={12} md={6}>
                <Field
                  name="name"
                  component={LiquidInputAdapter}
                  className={classes.sequenceInput}
                  rootClass={
                    nameValidationErrors.length > 0
                      ? classes.errorInputField
                      : classes.sequenceLabel
                  }
                  filled
                  value={name}
                  onBlur={handleOnBlur}
                  onChange={handleOnChange}
                  disabled={disable}
                  required
                  label={
                    <FormattedMessage {...messages.CONF_CRISPR_DESIGN_NAME} />
                  }
                />
                {nameValidationErrors.length === 0 && (
                  <div
                    className={
                      disable
                        ? classes.disableText
                        : clsx(
                            classes.baseContent,
                            GlobalCSS.globalHelpTextColor
                          )
                    }
                  >
                    <FormattedMessage
                      {...messages.CONF_CRISPR_DESIGN_NAME_INFO}
                    />
                  </div>
                )}
                <div className={classes.validateError}>
                  <ValidationErrors
                    errors={nameValidationErrors}
                    configuratorsRedesign
                  />
                </div>
              </Grid>
              <Grid item sm={12} md={3}>
                <Field
                  name="geneId"
                  component={LiquidInputAdapter}
                  className={classes.sequenceInput}
                  rootClass={
                    geneIdValidationErrors.length > 0
                      ? classes.errorInputField
                      : classes.sequenceLabel
                  }
                  filled
                  value={geneId}
                  onBlur={handleOnBlur}
                  onChange={handleOnChange}
                  disabled={disable}
                  label={<FormattedMessage {...messages.GENE_ID} />}
                />
                <div className={classes.validateError}>
                  <ValidationErrors
                    errors={geneIdValidationErrors}
                    configuratorsRedesign
                  />
                </div>
              </Grid>
              <Grid item sm={12} md={3}>
                <Field
                  name="geneSymbol"
                  component={LiquidInputAdapter}
                  className={classes.sequenceInput}
                  rootClass={
                    geneSymValidationErrors.length > 0
                      ? classes.errorInputField
                      : classes.sequenceLabel
                  }
                  filled
                  value={geneSymbol}
                  onBlur={handleOnBlur}
                  onChange={handleOnChange}
                  disabled={disable}
                  label={<FormattedMessage {...messages.GENE_SYMBOL} />}
                />
                <div className={classes.validateError}>
                  <ValidationErrors
                    errors={geneSymValidationErrors}
                    configuratorsRedesign
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={5}>
              <Grid item xs={12}>
                <Field
                  name="sequence"
                  component={LiquidInputAdapter}
                  className={classes.sequenceInput}
                  rootClass={
                    sequenceValidation.length > 0
                      ? classes.errorInputField
                      : classes.sequenceLabel
                  }
                  filled
                  autoComplete="off"
                  value={sequence}
                  onChange={(e) => {
                    setIsSequenceEmpty(true)
                    countText(convertToASCII(e.target.value))
                    setIsSequence(true)
                  }}
                  disabled={disable}
                  required
                  label={
                    <FormattedMessage
                      {...messages.CONF_CUSTOM_CRISPR_SEQUENCE}
                    />
                  }
                />
                <div
                  className={clsx(
                    GlobalCSS.sequenceBaseCountText,
                    disable
                      ? classes.disableText
                      : clsx(
                          classes.sequenceHelpText,
                          GlobalCSS.globalHelpTextColor
                        )
                  )}
                >
                  {sequenceValidation.length === 0 ? (
                    <span>{instructions}</span>
                  ) : (
                    <div>
                      {
                        <ValidationErrors
                          errors={sequenceValidation}
                          configuratorsRedesign
                        />
                      }
                    </div>
                  )}
                  <span>
                    <FormattedMessage {...messages.CONF_BASE_COUNT_standard} />{' '}
                    {baseCount}
                  </span>
                </div>
                {sequenceValidation.length === 0 && (
                  <div
                    className={
                      disable
                        ? classes.disableText
                        : clsx(
                            classes.baseContent,
                            GlobalCSS.globalHelpTextColor
                          )
                    }
                  >
                    <FormattedMessage {...messages.CONF_CRISPR_SEQUENCE_MSG} />
                  </div>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Formik>
      <Grid container spacing={1} className={classes.mt24}>
        <Grid item xs={3}>
          <Button
            id="customCrispr-add-to-list-button"
            variant="contained"
            size="small"
            color="primary"
            onClick={handleAddToList}
            disabled={disable}
            className={classes.addToListButton}
          >
            <FormattedMessage {...messages.ADD_TO_LIST} />
          </Button>
          {isSave && (validationLoading || saveLoading) && <CircleLoader />}
        </Grid>
      </Grid>
    </div>
  )
}

export default SequenceEntryItem
